export const MIN_CVV_LENGTH = 3;
export const MAX_CVV_LENGTH = 4;

export const LOW_CARD_BALANCE_MESSAGE = "Low balance. You need \u20B9 {0} more in your account";

export const JUSPAY_CARDBIN_URL =
    "https://api.juspay.in/cardbins/{0}?merchant_id=com.swiggy&options.check_tokenize_support=true";

export const CARD_ICONS: { [key: string]: { id: string; padding: number } } = {
    AMEX: {
        id: "Amex_ozga1w",
        padding: 0,
    },
    MASTERCARD: {
        id: "Mastercard_wqoea2",
        padding: 0,
    },
    SODEXO: {
        id: "PaymentLogos/FoodCards/2021_10/Sodexo",
        padding: 1,
    },
    VISA: {
        id: "Visa_lztyeu",
        padding: 3,
    },
    ZETA: {
        id: "Zeta_zybqrc",
        padding: 3,
    },
    DINERS: {
        id: "Diners_Club_thqpv8",
        padding: 0,
    },
    RUPAY: {
        id: "Rupay_l3lnhg",
        padding: 0,
    },
};

export const CARD_ICONS_V4: { [key: string]: { id: string; padding: number } } = {
    AMEX: {
        id: "PaymentLogos/paymentIcons/cards/amex",
        padding: 0,
    },
    MASTERCARD: {
        id: "PaymentLogos/paymentIcons/cards/mastercard",
        padding: 0,
    },
    SODEXO: {
        id: "portal/m/plx-logo_3x.png",
        padding: 10,
    },
    VISA: {
        id: "PaymentLogos/paymentIcons/cards/visa",
        padding: 3,
    },
    ZETA: {
        id: "PaymentLogos/FoodCards/2021_10/Zeta",
        padding: 3,
    },
    DINERS: {
        id: "PaymentLogos/Cards/2021_10/Diners",
        padding: 0,
    },
    RUPAY: {
        id: "PaymentLogos/paymentIcons/cards/rupay",
        padding: 0,
    },
};

export const CARD_BRAND = {
    SODEXO: "SODEXO",
    AMEX: "AMEX",
};

export const AMEX_CARD_CVV_LENGTH = 4;
export const DEFAULT_CVV_LENGTH = 3;

export const CARD_NUMBER_FORMAT_TITLE = "• • • • {0}";
export const CARD_NUMBER_FORMAT_MESSAGE = "• • • • • • • {0}";
export const CARD_ENDING_WITH = "Card ending with {0}";
export const CARD_ISSUER_NAME = "{0} Card";

export const DEFAULT_ADD_NEW_CARD_ERROR_STATE = {
    cardNumber: false,
    cvv: false,
    expiry: false,
    name: false,
    nickName: false,
};

export const PENNY_TXN_AMOUNT = "2";
export const SECURED_CARD_MESSAGE =
    "By enabling this card, you agree to secure it with {0} for seamless future payments.";
export const CARD_TYPE_CREDIT = "CREDIT";
export const CARD_TYPE_DEBIT = "DEBIT";

export const CVV_BOTTOMSHEET_TITLE = "CVV for card";

export const CONTINUE = "Continue";

export const CARD_BIN_NUMBER_MAX_LIMIT = 9;
